import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'groupId',
      type: 'select',
      label: '部门',
      clearable: true,
      placeholder: '请选择部门',
      options: []
    },
    {
      field: 'empIds',
      type: 'select',
      label: '员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择员工',
      options: []
    },
    {
      label: '资源渠道',
      type: 'select',
      field: 'resourceType',
      clearable: true,
      placeholder: '请选择资源渠道',
      options: [
        { title: '诊股', value: 0 },
        { title: '信息流', value: 1 },
        { title: '百度直播', value: 2},
        { title: '视频号直播', value: 3},
        { title: '三方视频号直播', value: 4},
        { title: '打新', value: 5},
        { title: '送股', value: 6},
        { title: '半马星', value: 7},
        { title: '时微', value: 8},
        { title: '烜颐融', value: 9},
        { title: '与牛共行', value: 10},
        { title: '湖北虎符', value: 11},
      ],
      isDisabled: true
    },
    {
      field: 'corpId',
      type: 'select',
      label: '主体',
      placeholder: '请选择主体',
      filterable: true,
      clearable: true,
      options: []
    },
    {
      label: '企微账号',
      field: 'corpWechatNo',
      type: 'input',
      placeholder: '请输入企微账号'
    },
    {
      label: '账号ID',
      field: 'account',
      type: 'input',
      placeholder: '请输入账号ID'
    },
    {
      field: 'applyDate',
      type: 'datepicker',
      label: '申请日期',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    {
      label: '资源进度',
      type: 'select',
      field: 'progress',
      class: 'xxxx',
      clearable: true,
      options: [
        { title: '未开始', value: 0 },
        { title: '在推', value: 1 },
        { title: '打满', value: 2 }
      ],
      placeholder: '请选择资源进度'
    },
    {
      label: '颜色标记',
      type: 'select',
      field: 'tag',
      class: 'xxxx',
      clearable: true,
      options: [
        {
          value: '#FFC000',
          title: '打满标记完渠道-深黄'
        },
        {
          value: '#548235',
          title: '刚打满缓存-深绿'
        },
        {
          value: '#A9D18E',
          title: '在推-浅绿'
        },
        {
          value: '#FFFFFF',
          title: '待排-白色'
        },
        {
          value: '#A6A6A6',
          title: '异常-深灰'
        }
      ],
      placeholder: '请选择颜色标记'
    }
  ]
}
